<template>
  <fieldset class="flex flex-wrap items-center gap-3" :aria-label="t('aria-label')">
    <slot />
  </fieldset>
</template>
<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});
</script>
<i18n>
{
  "en": {
    "aria-label": "Filters"
  },
  "fr": {
    "aria-label": "Filtres"
  }
}
</i18n>
